import React from 'react';
import PropTypes from 'prop-types';

export const PhotoPlaceholder = ({ handleDelete }) => (
  <div className="item-modal__photo-card placeholder-photo">
    <button
      type="button"
      onClick={handleDelete}
      className="item-modal__photo-icon item-modal__photo-icon--delete"
    />
    <span className="main-loader-spinner" />
  </div>
);

PhotoPlaceholder.propTypes = {
  handleDelete: PropTypes.func
};
